<template>
  <section>
    <!-- search -->
    <form @submit.prevent="loadData">
      <div class="section_search">
        <div class="tray">
          <div class="row">
            <div class="cell">
              <select
                class="selectBox"
                style="display:inline-block;width:100px;"
                v-model="formData.range"
              >
                <option value="DAILY">일간</option>
                <option value="WEEKLY">주간</option>
                <option value="MONTHLY">월간</option>
                <option value="YEARLY">년간</option>
              </select>

              <!-- 일간 -->
              <DatePicker
                v-if="formData.range === 'DAILY'"
                :value="$utils.calcDate(null, '-1d')"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <WeekPicker
                v-if="formData.range === 'WEEKLY'"
                class="blank"
                width="300px"
                ref="picker"
                :value="$utils.calcDate(new Date(), '-1w')"
                :maxDate="new Date()"
              />
              <MonthPicker
                v-if="formData.range === 'MONTHLY'"
                class="blank"
                ref="picker"
                :maxDate="new Date()"
              />
              <YearPicker
                v-if="formData.range === 'YEARLY'"
                class="blank"
                ref="picker"
                minDate="2017"
                :maxDate="new Date()"
              />
            </div>
            <span class="label">지역</span>
            <div class="cell">
              <GroupSelector permissionCode="statistic" :useGroup="false" ref="groupSelector" />
              <button type="submit" class="btn_search">검색</button>
            </div>
          </div>
        </div>
      </div>
    </form>
    <!-- //search -->

    <div v-if="res" ref="tableWrap">
      <h4 class="section_title">
        <span class="ico"></span>
        전체
      </h4>
      <ItemTable title="전체" listKey="all" :itemArray="res.allHealthUseList" divName="전체" />

      <h4 class="section_title">
        <span class="ico"></span>
        지역별
      </h4>
      <ItemTable title="지역별" listKey="area" :itemArray="res.areaHealthUseList" divName="지역" />

      <h4 class="section_title">
        <span class="ico"></span>
        연령대별
      </h4>
      <ItemTable title="연령대별" listKey="age" :itemArray="res.ageHealthUseList" divName="연령대" />
    </div>

    <div class="section_button none_paginate">
      <ExcelDownloadButton
        v-if="res"
        :filename="$utils.excelName('건강백세', '이용통계')"
        :tablesContainer="$refs.tableWrap"
      />
      <HelpButton contentId="HELP_05" />
    </div>
  </section>
</template>

<script>
import ItemTable from "./ItemTable";

export default {
  components: { ItemTable },
  data() {
    return {
      res: null,
      resPeriod: "",
      formData: {
        range: "WEEKLY",
        state: "",
        city: ""
      }
    };
  },
  methods: {
    loadData() {
      const options = this.requestOptions();
      this.$axios
        .get("/admin/happy/stats/v2/health/use", options)
        .then(({ data }) => {
          this.res = data;
        });
    },
    requestOptions() {
      const group = this.$refs.groupSelector.getData();
      const startDate = this.$refs.picker.getDate();

      return {
        params: _.merge(this.formData, {
          searchDate: this.$utils.dateText(startDate),
          orgCode: group.orgId,
          state: group.stateId,
          city: group.cityId
        })
      };
    }
  },
  mounted() {
    this.loadData();
  }
};
</script>
